import { createContext } from 'react';
import { IDataTableProps } from '@src/molecules/DataTable/models';

interface IDataTableBodyRowContext extends Pick<IDataTableProps, 'view'> {
  hovered: boolean;
}
export const DataTableBodyRowContext = createContext<IDataTableBodyRowContext>({
  hovered: false,
  view: 'default',
});
